import React, { Component } from 'react'
import styled from 'styled-components'
import { media } from 'app/assets/styles'
import { colors } from 'shared/assets/styles'
import { NavigationItem } from './NavigationItem'
import type { MenuItemDTO } from 'shared/types'
import { CaptionText } from 'app/common/typography'
import { FormattedMessage } from 'react-intl'

const { chalk } = colors

type Props = {
    close: () => void,
    leftItems: Array<MenuItemDTO>,
    rightItems: Array<MenuItemDTO>,
    fetchPageData: () => void,
    error?: any,
    networkError?: any
}

type State = {
    prevScrollPosition: number,
    selectedTab: ?number
}

class NavigationMenuComponent extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            prevScrollPosition: 0,
            selectedTab: null
        }
    }

    componentDidMount() {
        const { fetchPageData } = this.props
        this.setState({ prevScrollPosition: window.scrollY })
        fetchPageData()
    }

    componentWillUnmount() {
        setTimeout(() => window.scrollTo(0, this.state.prevScrollPosition), 0)
    }

    setSelectedTab = (tabIndex: ?number) => {
        this.setState({
            selectedTab: tabIndex === this.state.selectedTab ? null : tabIndex
        })
    }

    render() {
        const { close, leftItems, rightItems, error, networkError } = this.props
        const { selectedTab } = this.state

        return (
            <NavigationOverlay>
                <Menu>
                    {!!error || !!networkError ? (
                        <Container>
                            <CaptionText color="white">
                                <FormattedMessage id="error.section.title" />
                            </CaptionText>
                        </Container>
                    ) : (
                        <Items>
                            <Column>
                                {!!leftItems &&
                                    leftItems.map(
                                        (item: MenuItemDTO, index: number) => (
                                            <NavigationItem
                                                index={index}
                                                close={close}
                                                item={item}
                                                selectedTab={selectedTab}
                                                setSelectedTab={
                                                    this.setSelectedTab
                                                }
                                            />
                                        )
                                    )}
                            </Column>
                            <Column>
                                {!!rightItems &&
                                    rightItems.map(
                                        (item: MenuItemDTO, index: number) => (
                                            <NavigationItem
                                                index={index + leftItems.length}
                                                close={close}
                                                item={item}
                                                selectedTab={selectedTab}
                                                setSelectedTab={
                                                    this.setSelectedTab
                                                }
                                            />
                                        )
                                    )}
                            </Column>
                        </Items>
                    )}
                </Menu>
            </NavigationOverlay>
        )
    }
}

const NavigationOverlay = styled.section`
    min-height: 100%;
    height: auto;
    background-color: ${chalk};
`

const Menu = styled.nav`
    padding: 15px 0 15px;
    ${media.medium`
        width: 1060px;
        padding: 10% 0 50px 0;
        margin: 0 auto;
    `};
`

const List = styled.ul`
    list-style-type: none;
`

const Items = styled(List)`
    ${media.medium`
        display: flex;
        flex-direction: row;
    `};
`

const Column = styled.div`
    ${media.medium`
        flex-grow: 1;
        flex-basis: 50%;
    `};
`

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`

export { NavigationMenuComponent }
